import moment from 'moment';
import { format, parseISO, toDate, compareAsc, compareDesc } from 'date-fns';

export interface CampaignResponse {
	statusIdentifier: 'string';
	count: number;
}
export interface DeviceResponseData {
	statusId: number;
	count: number;
	status: string;
}
export interface DeviceResponse {
	deviceType: string;
	responseData: Array<DeviceResponseData>;
}

export interface DashboardViewershipResponseList {
	date: string;
	actualViewershipCount: number;
	potentialViewershipCount: number;
}
export interface RunningCampaignResponse {
	campaignCount: number;
	deviceCount: number;
	mainLocationCount: number;
	viewershipCount: number;
}
export interface ClientDashboard {
	campaignResponse: Array<CampaignResponse>;
	viewershipDateList: Array<string>;
	actualViewershipCountList: Array<number>;
	potentialViewershipCountList: Array<number>;
	deviceResponse: Array<DeviceResponse>;
	runningCampaignResponse: RunningCampaignResponse;
}

export const getDashboardFromJson = (json: any): ClientDashboard => {
	const dashboard: ClientDashboard = {} as ClientDashboard;
	dashboard.campaignResponse = [];
	const campResponse = json.campaignResponse;
	campResponse.forEach((camp: any) => {
		const campData: CampaignResponse = {} as CampaignResponse;
		campData.statusIdentifier = camp.statusIdentifier;
		campData.count = camp.count;
		dashboard.campaignResponse.push(campData);
	});
	dashboard.actualViewershipCountList = [];
	dashboard.potentialViewershipCountList = [];
	dashboard.viewershipDateList = [];
	const dashboardViewershipResponse = json.dashboardViewershipResponseList;
	dashboardViewershipResponse.forEach((view: any) => {
		const viewData: DashboardViewershipResponseList = {} as DashboardViewershipResponseList;
		viewData.date = format(toDate(parseISO(view.date)), 'dd-MM-yyyy');
		// viewData.date = moment(view.date).format('YYYY-MM-DD');
		viewData.actualViewershipCount = view.actualViewershipCount;
		viewData.potentialViewershipCount = view.potentialViewershipCount;
		dashboard.actualViewershipCountList.push(viewData.actualViewershipCount);
		dashboard.potentialViewershipCountList.push(viewData.potentialViewershipCount);
		dashboard.viewershipDateList.push(viewData.date);
	});
	dashboard.viewershipDateList.reverse();
	dashboard.actualViewershipCountList.reverse();
	dashboard.potentialViewershipCountList.reverse();
	dashboard.deviceResponse = [];
	const devResponse = json.deviceResponse;
	devResponse.forEach((device: any) => {
		const respData: DeviceResponse = {} as DeviceResponse;
		respData.deviceType = device.deviceType;
		respData.responseData = [];
		const devData = device.responseData;
		devData.forEach((data: any, index: number) => {
			const resp: DeviceResponseData = {} as DeviceResponseData;
			resp.statusId = index;
			resp.count = data.count;
			resp.status = data.status;
			respData.responseData.push(resp);
		});
		dashboard.deviceResponse.push(respData);
	});
	dashboard.runningCampaignResponse = json.runningCampaignResponse;
	return dashboard;
};
